export default "__VITE_ASSET__8cb72875__"